export default {
    'form.name':'姓名',
    'form.email':'郵箱',
    'form.email.code':'郵箱驗證碼',
    'form.country':'國家',
    'form.password':'密碼',
    'form.requiredText':'請輸入',
    'form.send-emil-success':'驗證碼已發送',
    'form.send-emil-fail':'驗證碼發送失敗',
    'form.send-email-code':'獲取驗證碼',
    'form.email-valid-error':'郵箱格式錯誤',
    'form.second-send-again':'秒後重發',
    'form.upload.idFront':'身份證正面',
    'form.upload.idBack':'身份證背面',
    'form.upload.validType':'僅支援上傳 JPG/PNG 格式的圖片！',
    'form.upload.validSize':'圖片大小不能超過',
    'form.last-name':'姓氏',
    'form.first-name':'名字',
    'form.birthday':'生日',
    'form.nickname':'暱稱',
    'form.phone':'手機',
    'form.state':'省份',
    'form.city':'城市',
    'form.address':'地址',
    'form.registe-success':'註冊成功',
    'form.login-success':'登錄成功',
    'form.policy.title':'隱私政策',
    'form.policy.require':'請查看並同意隱私政策',
    'form.policy.text':'查看隱私政策',
    'form.submit.success':'提交成功',
    'form.submit.fail':'提交失敗',
}